import { createEntityAdapter } from '@reduxjs/toolkit';
import { TripLegSearchResponseItem } from '../models/trip-leg-search.model';
import { Driver } from '../models/driver.model';
import { Vehicle, TripLegDriverLocation } from '../models/reservation.model';

const tripLegAdapter = createEntityAdapter<
  TripLegSearchResponseItem & {
    driver?: Driver;
    vehicle?: Vehicle;
    tripLegDriverLocations?: TripLegDriverLocation[];
  }
>({
  selectId: (tripLeg) => tripLeg.tripLegReferenceID,
});

export { tripLegAdapter };
